define('app/views/login_form_view',['app/setup', 'app/models/user'], function(takhfifan) {

  takhfifan.LoginFormView = takhfifan.BaseView.extend({

    events: {
      'keypress': 'submit',
      'click #tkhLoginBtn': 'submit',
      'click .social-login': 'socialLoginSubmit'
    },

    initialize: function() {
      var _this = this;
      this.model.set('loginUrl', this.$('form').first().prop('action'));

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.model.set('formKey', formKey);
      }, this);

      takhfifan.eventHub.on('socialconnect', function(socialconnect) {
        this.activateSocialButtons(socialconnect);
      }, this);

      takhfifan.eventHub.on('customer:login', function(customer) {
        $('body').removeClass('limit-scroll');
        if (this.$el.is(':visible')) {
          this.hideSuccess(customer);
        }
        $('.tkh-header').addClass('customer-logged-in');
      }, this);

      takhfifan.eventHub.on('customer:loginForm', function() {
        $('body').addClass('limit-scroll');
        this.render();
      }, this);

      takhfifan.eventHub.on('customer:loginError', function(errors) {
          this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('customer:loginEnd', function() {
        this.$('#tkhLoginBtn').empty().append(_this.loginBtnContent);
      }, this);

      this.loginBtnContent = this.$('#tkhLoginBtn').html();
      this.loggingIn = false;

      Backbone.Validation.bind(this);
    },

    renderErrors: function(errors) {
      this.loggingIn=false;
      this.$('#tkhLoginBtn').empty().append(this.loginBtnContent);
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+
          e +
        '</p></div>';
        var $li = $('<li></li>');
        $li.html(preFormattedError);
        $errors.append($li);
      });
      $errors.show();
    },

    render: function() {
      var _this = this,
      socialLinks = this.$el.find('.social-login');
      this.overlay = $('.modal-overlay');

      //update social connects links.
      socialLinks.hide();
      $.get('/ajax/account/updateSocialConnectLink', function (data) {
        _this.activateSocialButtons(data);
        socialLinks.show();
      });
      this.overlay
      .fadeIn(300)
      .on('click', function() {
        $('body').removeClass('limit-scroll');
        _this.$el.fadeOut(300);
        $(this).fadeOut(300);
      });
      this.$el.fadeIn(300, function() {
        _this.$('input[name=username]').focus();
      });
    },

    hideSuccess: function(customer) {
      this.$('.alert-error').empty().hide();
      this.$el.hide();
      var successMsg = takhfifan.isYadisa? i18n.t('successfully_logged_in_yadisa'):
          i18n.t('successfully_logged_in_takhfifan');

      takhfifan.eventHub.trigger('message:show', {
        type: 'success',
        msg: successMsg
      });
    },

    submit: function(e) {
      this.$('.alert-error').empty().fadeOut();
      if(!this.loggingIn) {
          if (e.type != 'click' && e.which != 13) {
          return;
        }
        this.model.set({
          username: this.$('input[name="username"]').first().val(),
          password: this.$('input[name="password"]').first().val()
        }, { validate: true });

        if (this.model.isValid(['username', 'password'])) {
          this.loggingIn=true;
          this.$('#tkhLoginBtn').empty().append('<span class="spinner"></span>');
          this.model.login();
          this.setResetSessionFlag();
          takhfifan.eventHub.trigger('ga:checkoutOption', {
            "step": 2,
            "option": "user login"
          });
        } else {
          e.preventDefault();
        }
      }
    },

    activateSocialButtons: function(data) {
      this.$('a.tkh-google-login').prop('href', data.google);
      this.$('a.tkh-facebook-login').prop('href', data.facebook);
      this.$('a.tkh-twitter-login').prop('href', data.twitter);
      this.$('a.tkh-yahoo-login').prop('href', data.yahoo);
    },

    socialLoginSubmit: function (e) {
      e.preventDefault();
      this.setResetSessionFlag();
      window.location.href = $(e.currentTarget).attr('href');
    }

  });

var user = new takhfifan.User();

$('.tkh-login-form').each(function(){
  var $this = $(this);
  new takhfifan.LoginFormView({
    el: $this,
    model: user
  });
});

});

